export default __webpack_public_path__ + "static/media/B-T-HTMATE.88c475f3.svg";